
<template>
  <div 
    class="cluster"
    :style="{ 
      right:`${x}px`,
      top:`${y}px`,
      transform: `rotate(${r}deg)`
    }"
  >
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
    <div class="leaf"></div>
  </div>
</template>

<script>
export default {
  name: "LeafCluster",
  props: [
    'x', 'y', 'r'
  ],
}
</script>

<style>
.cluster {
  position: absolute;
  margin-left: -35px;
  margin-top: 5px;
  height: 50px;
  width:45px;
  transform: rotate(215deg);
  transform-origin: top left;
}
.cluster .leaf {
  position: absolute;
  height: 25px;
  width: 10px;
  border-left: 2px ridge var(--leaf);
  border-radius: 50%/20px;
  transform-origin: bottom left;
}
.cluster .leaf:nth-of-type(1) {
  transform: rotate(20deg);
}
.cluster .leaf:nth-of-type(2) {
  transform: rotate(40deg);
}
.cluster .leaf:nth-of-type(3) {
  transform: rotate(60deg);
}
.cluster .leaf:nth-of-type(4) {
  transform: rotate(80deg);
}
.cluster .leaf:nth-of-type(5) {
  transform: rotate(100deg);
}
.cluster .leaf:nth-of-type(6) {
  transform: rotate(120deg);
}
.cluster .leaf:nth-of-type(7) {
  transform: rotate(140deg);
}
.cluster .leaf:nth-of-type(8) {
  transform: rotate(160deg);
}
.cluster .leaf:nth-of-type(9) {
  transform: rotate(180deg);
}
/* .cluster .leaf:nth-of-type(10) {
  transform: rotate(200deg);
}
.cluster .leaf:nth-of-type(11) {
  transform: rotate(220deg);
}
.cluster .leaf:nth-of-type(12) {
  transform: rotate(240deg);
}
.cluster .leaf:nth-of-type(13) {
  transform: rotate(260deg);
}
.cluster .leaf:nth-of-type(14) {
  transform: rotate(280deg);
}
.cluster .leaf:nth-of-type(15) {
  transform: rotate(300deg);
}
.cluster .leaf:nth-of-type(16) {
  transform: rotate(320deg);
}
.cluster .leaf:nth-of-type(17) {
  transform: rotate(340deg);
}
.cluster .leaf:nth-of-type(18) {
  transform: rotate(360deg);
} */
.cluster .leaf:nth-of-type(-n+9) {
  margin-top:6px;
  margin-left: -12px;
  border-right: 2px ridge var(--leaf);
  border-left: none;
  border-radius: 50%/20px;
  transform-origin: bottom right;
}
.cluster .leaf:nth-of-type(10) {
  transform: rotate(200deg) scale(-1);
}
.cluster .leaf:nth-of-type(11) {
  transform: rotate(220deg) scale(-1);
}
.cluster .leaf:nth-of-type(12) {
  transform: rotate(240deg) scale(-1);
}
.cluster .leaf:nth-of-type(13) {
  transform: rotate(260deg) scale(-1);
}
.cluster .leaf:nth-of-type(14) {
  transform: rotate(280deg) scale(-1);
}
.cluster .leaf:nth-of-type(15) {
  transform: rotate(300deg) scale(-1);
}
.cluster .leaf:nth-of-type(16) {
  transform: rotate(320deg) scale(-1);
}
.cluster .leaf:nth-of-type(17) {
  transform: rotate(340deg) scale(-1);
}
.cluster .leaf:nth-of-type(18) {
  transform: rotate(360deg) scale(-1);
}
</style>


